import { chassis, standards, vehicleType } from "../../../../data/vehicle";
import { VehicleFeature } from "../../../../interface/transportation";
import { Button } from "../../../atoms/Buttons";
import { InputSelect } from "../../../atoms/Inputs/InputSelect";
import { CmpInfoCheckBox } from "../CmpInfoCheckBox";
import * as S from "./cmpCarInfoChange.styles";

interface CmpCarInfoContentProps {
  onCloseHandler: () => void;
  register: any;
  handleSubmit: any;
  onSubmit: (data: any) => Promise<any>;
  setValue: any;
  watch: any;
}

export const CmpCarInfoChangeContent = ({
  onCloseHandler,
  register,
  handleSubmit,
  onSubmit,
  setValue,
  watch,
}: CmpCarInfoContentProps) => {
  return (
    <S.CmpCarInfoChange onSubmit={handleSubmit(onSubmit)}>
      <S.CmpCarInfoConentBox>
        <S.CmpItemTit>차량정보</S.CmpItemTit>
        <S.CmpCarInfoBox>
          <input
            type="text"
            required
            className="vehicleNumber"
            placeholder="차량번호"
            {...register("vehicleNumber")}
          />

          <InputSelect
            displayExpr="display"
            keyExpr="id"
            placeholder="차종"
            items={vehicleType}
            register={register("vehicleType")}
            value={watch("vehicleType")}
          />

          <InputSelect
            displayExpr="display"
            keyExpr="id"
            placeholder="규격"
            items={standards}
            register={register("standard")}
            value={watch("standard")}
          />

          <InputSelect
            displayExpr="display"
            keyExpr="id"
            placeholder="샤시"
            items={chassis}
            register={register("chassis")}
            value={watch("chassis")}
          />
        </S.CmpCarInfoBox>

        <S.CmpItemTit>차량 특성</S.CmpItemTit>
        <S.CmpCarInfoCheckBox>
          <S.CmpCarCheckDetail>
            <CmpInfoCheckBox
              label="위험물"
              register={register("vehicleFeatures")}
              value={VehicleFeature.DANGEROUS_GOODS}
              setValue={setValue}
              watch={watch}
            />
            <CmpInfoCheckBox
              label="보세운송"
              register={register("vehicleFeatures")}
              value={VehicleFeature.BOND_MOVEMENT}
              setValue={setValue}
              watch={watch}
            />
            <CmpInfoCheckBox
              label="발전기"
              register={register("vehicleFeatures")}
              value={VehicleFeature.GENERATOR}
              setValue={setValue}
              watch={watch}
            />
            <CmpInfoCheckBox
              label="냉장"
              register={register("vehicleFeatures")}
              value={VehicleFeature.REFRIGERATED}
              setValue={setValue}
              watch={watch}
            />
            <CmpInfoCheckBox
              label="냉동"
              register={register("vehicleFeatures")}
              value={VehicleFeature.FROZEN}
              setValue={setValue}
              watch={watch}
            />
          </S.CmpCarCheckDetail>
        </S.CmpCarInfoCheckBox>
      </S.CmpCarInfoConentBox>
      <S.CmpButtonBox>
        <div className="small">
          <Button
            type="button"
            color="transparent"
            size="full"
            onClick={onCloseHandler}
          >
            취소
          </Button>
        </div>
        <Button type="submit" size="full">
          저장
        </Button>
      </S.CmpButtonBox>
    </S.CmpCarInfoChange>
  );
};
